import { Tooltip, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Brightness1OutlinedIcon from '@mui/icons-material/Brightness1Outlined';

export default function StatusCell({ value }) {
  if (!value) {
    return null;
  }
  if (value.code === 'ok') {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <CheckCircleIcon color="success" />
      </Box>
    );
  }

  if (value.code === 'static') {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Brightness1Icon color="success" />
          <Box
            sx={{
              position: 'absolute',
              top: '52%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: '#fff',
              fontWeight: 'bold',
              fontSize: 15,
              pointerEvents: 'none',
            }}
          >
            S
          </Box>
        </Box>
      </Box>
    );
  }

  const hasMessages = value.messages && value.messages.length > 0;
  const tooltipContent = hasMessages ? (
    <div>
      {value.messages.map((msg, index) => (
        <div key={index}>{msg}</div>
      ))}
    </div>
  ) : null;

  if (value.code.includes('underflow')) {
    const icon = value.code.includes('static') ? (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Brightness1OutlinedIcon color="success" />
          <Box
            sx={{
              position: 'absolute',
              top: '52%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: 'success.main',
              fontWeight: 'bold',
              fontSize: 15,
              pointerEvents: 'none',
            }}
          >
            S
          </Box>
        </Box>
      </Box>
    ) : (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <CheckCircleOutlineIcon color="success" />
      </Box>
    );

    if (tooltipContent) {
      return (
        <Tooltip title={tooltipContent} arrow>
          {icon}
        </Tooltip>
      );
    }
    return icon;
  }

  if (value.code === 'warning') {
    const icon = (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <WarningAmberIcon color="warning" />
      </Box>
    );

    if (tooltipContent) {
      return (
        <Tooltip title={tooltipContent} arrow>
          {icon}
        </Tooltip>
      );
    }
    return icon;
  }

  return null;
}
